<template>
    <div id="contenedor-principal-consulta-publica-notificaciones" class="container-fluid">
        <!-- SECCION DE ENCABEZADOS -->
        <div id="encabezados">
            <h1>Consulta de cédulas de notificación</h1>
            <h4>LA CONSULTA VIRTUAL SOLO TIENE CARACTER INFORMATIVO Y NO PRODUCE EFECTO LEGAL ALGUNO</h4>
            <div class="hr-titulo"></div>
            <div class="contenedor-descripcion">
                    <h6 class="font-weight-bold"><i class="fas fa-info-circle"></i>&nbsp;Estatus de la notificación </h6>                        
                    <h6>Pendiente + Fecha de envió a dirección vacía: La cédula aún no ha sido enviada por el Juzgado a la Dirección de Notificadores para su realización.
                        Pendiente + Fecha de envió a dirección llena: La cédula se encuentra en la Dirección de notificadores, pero la notificación aún no se lleva a cabo.
                        Realizada: Se entregó la notificación.
                        Razonada: No se pudo entregar la notificación.
                    </h6>
            </div>
        </div>        
        <!-- SECCION DE CONSULTA -->
        <div id="seccion-consulta" class="row">
            <!-- SECCION INFORMATIVA -->
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-2 pt-0 mt-3">
                <div class="titulo-contenedores-seccion container-fluid">
                    <h5 class="font-weight-bold"><i class="fas fa-list"></i>&nbsp;&nbsp;Listado de cédulas encontradas</h5>
                </div>
                <!-- SECCION FILTROS DE BUSQUEDA -->
                <div class="contenedor-color-negro row no-gutters pb-2">
                    <!-- <h6 class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-4 pt-2 pb-2 texto-filtros form-inline">
                        ACCIONES
                        <div id="seccion-acciones" class="d-flex justify-content-start mr-4">
                            <button type="button" @click="iniciarProcesoBusquedaDeCedulas" class="btn btn-primary mr-2"><i class="fas fa-search"></i>&nbsp;&nbsp;Buscar</button>
                            <button type="button" @click="limpiarFiltros" class="btn btn-primary"><i class="fas fa-redo-alt"></i>&nbsp;&nbsp;Limpiar filtros</button>
                        </div>
                        <div style="border-left:2px solid #fff;height:2em;" class="mr-3"></div>
                        <i @click="tablaCedulas.filtros.grupos.rangoDeFechas.activo = !tablaCedulas.filtros.grupos.rangoDeFechas.activo" 
                           :class="(!tablaCedulas.filtros.grupos.rangoDeFechas.activo) ? 'far fa-square texto-filtros' : 'fas fa-check-square texto-filtros'"
                           style="cursor: pointer;"></i>&nbsp;&nbsp;Agregar rango de fechas
                    </h6> -->
                    <!-- FILTRO DE JUZGADO -->
                    <div class="form-group col-xs-3 col-sm-3 col-md-3 col-lg-3 pr-4 pt-0">
                        <h6>Juzgado</h6>
                        <C001Area 
                            :class="[tablaCedulas.filtros.filtroAreaInformativo ? 'catalogoInformativo p-0 m-0' : 'p-0 m-0']" 
                            v-on:valorParaElPadre="evtCambioDeJuzgado" 
                            :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                            :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                            :idDelInput="'TipoAreaVCBCED'" 
                            :parametros="{ Materias: [ { MateriaId: 2, Activo: true }, 
                                                       { MateriaId: 3, Activo: true }, 
                                                       { MateriaId: 4, Activo: true }, 
                                                       { MateriaId: 5, Activo: true } , 
                                                       { MateriaId: 13, Activo: true } ] ,
                                           elementosAOmitir:[17,18,24]}" 
                            :valorDefinido="tablaCedulas.filtros.juzgadoId" 
                            :key="'KTipoAreaVCBCED' + tablaCedulas.filtros.contFJuzgado"></C001Area>
                    </div>
                    <!-- FILTRO NUMERO DE EXPEDIENTE -->
                    <div id="filtros" class="form-group col-xs-3 col-sm-3 col-md-3 col-lg-3 pr-4 pt-0">
                        <h6>Número de expediente</h6>
                        <div class="input-group">
                            <div class="input-group-append">
                                <div class="input-group-text"><i class="fa fa-folder"></i></div>
                            </div>
                            <input class="form-control input-sm input-xs input-md input-lg py-2 border-left-0 border" type="text" v-model="tablaCedulas.filtros.numeroExpediente" v-mask="'####/####'" placeholder="####/####">
                        </div>
                    </div>
                    <!-- FILTRO PARA EL TIPO DE DOCUMENTO -->
                    <div class="form-group col-xs-3 col-sm-3 col-md-3 col-lg-3 pr-4 pt-0">
                        <h6>Tipo de documento</h6>
                        <C004TiposDocumento 
                            v-on:valorParaElPadre="evtCambioTipoDeDocumento" 
                            :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                            :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                            :idDelInput="'CTipoDeDocumento'" 
                            :parametros="tablaCedulas.filtros.tipoDeDocumento.parametros" 
                            :valorDefinido="tablaCedulas.filtros.tipoDeDocumento.tipoDeDocumentoId" 
                            :key="'KCTipoDeDocumento_SIS_VIEJO' + tablaCedulas.filtros.tipoDeDocumento.contadorRender"></C004TiposDocumento>
                    </div>
                    <!-- FILTROS RANGO DE FECHAS -->
                    <!-- <div class="form-group col-xs-3 col-sm-3 col-md-3 col-lg-3 pr-4 pt-0">
                        <h6 for="fechaInicial">Fecha inicial&nbsp;<i v-if="!tablaCedulas.filtros.grupos.rangoDeFechas.activo" class="fas fa-ban text-danger"></i></h6>
                        <input type="date" id="fechaInicial" v-model="tablaCedulas.filtros.fechaInicial" :class="[(tablaCedulas.filtros.grupos.rangoDeFechas.activo) ? 'form-control' : 'form-control catalogoInformativo']" />
                    </div>
                    <div class="form-group col-xs-3 col-sm-3 col-md-3 col-lg-3 pr-4 pt-0">
                        <h6 for="fechaFinal">Fecha final&nbsp;<i v-if="!tablaCedulas.filtros.grupos.rangoDeFechas.activo" class="fas fa-ban text-danger"></i></h6>
                        <input type="date" id="fechaFinal" v-model="tablaCedulas.filtros.fechaFinal" :class="[(tablaCedulas.filtros.grupos.rangoDeFechas.activo) ? 'form-control' : 'form-control catalogoInformativo']" />
                    </div> -->
                    <div class="form-group col-xs-3 col-sm-3 col-md-3 col-lg-3 align-self-end no-gutters pr-4 pt-0">
                        <div id="seccion-acciones" class="form-group d-flex justify-content-end mr-4">
                            <button type="button" @click="iniciarProcesoBusquedaDeCedulas" class="btn btn-primary mr-2"><i class="fas fa-search"></i>&nbsp;&nbsp;Buscar</button>
                            <button type="button" @click="limpiarFiltros" class="btn btn-primary"><i class="fas fa-redo-alt"></i>&nbsp;&nbsp;Limpiar filtros</button>
                        </div>
                    </div>
                </div>
                <div class="container-fluid contenedor-color-negro contenedor-tabla-historico-CEDULAS-SINOJ">
                    <table
                        class="table table-striped table-light table-hover"
                        :id="tablaCedulas.ID"              
                        data-toggle="table"
                        data-pagination="true"
                        data-undefined-text="Sin información"
                        data-maintain-selected="true"  
                        data-page-size = "5"
                        data-page-list="[5,10,20]"
                        data-click-to-select="false"
                        data-show-toggle="false"
                        data-show-pagination-switch="false"
                        data-search="false">
                        <thead class="thead-dark">
                            <!-- <tr>
                                <th data-halign="center" data-width="15" data-align="center" data-field="Consecutivo" data-sortable="true">
                                    Consecutivo
                                </th>
                                <th data-halign="center" data-width="15" data-align="center" data-field="nombreTipoDocumento" data-sortable="true">
                                    Tipo de documento
                                </th>
                                <th data-halign="center" data-width="15" data-align="center" data-field="TipoCedula" data-sortable="true">
                                    Tipo de cedula
                                </th>
                                <th data-events="operateEvents" data-halign="center" data-width="25" data-align="center" data-field="Domicilio" data-sortable="true">
                                    Domicilio
                                </th>
                                <th data-halign="center" data-width="20" data-align="center" data-field="PersonaANotificar" data-sortable="true">
                                    Persona a notificar
                                </th>
                                <th data-halign="center" data-width="20" data-align="center" data-field="Estatus" data-sortable="true">
                                    Estatus
                                </th>
                                <th data-halign="center" data-width="15" data-align="center" data-field="fechaResultado" data-sortable="true">
                                    Realizacion de notificación
                                </th>
                            </tr> -->
                            <tr>
                                <th data-toggle="tooltip" data-placement="top" title="Folio" data-halign="center" data-width="10" data-align="center" data-field="Folio" data-sortable="true">
                                    Folio
                                </th>
                                <th data-toggle="tooltip" data-placement="top" title="Juzgado" data-halign="center" data-width="15" data-align="center" data-field="Juzgado" data-sortable="true">
                                    Juzgado
                                </th>
                                <th data-toggle="tooltip" data-placement="top" title="Numero de documento" data-halign="center" data-width="7" data-align="center" data-field="Consecutivo" data-sortable="true">
                                    Numero de documento
                                </th>
                                <th data-toggle="tooltip" data-placement="top" title="Tipo de documento" data-halign="center" data-width="10" data-align="center" data-field="nombreTipoDocumento" data-sortable="true">
                                    Tipo de documento
                                </th>
                                <th data-toggle="tooltip" data-placement="top" title="Fecha envió a dirección de notificadores" data-halign="center" data-width="10" data-align="center" data-field="FechaEnvioADireccion" data-sortable="true">
                                    Fecha envió a dirección
                                </th>
                                <th data-toggle="tooltip" data-placement="top" title="Persona a notificar" data-halign="center" data-width="15" data-align="center" data-field="PersonaANotificar" data-sortable="true">
                                    Persona a notificar
                                </th>
                                <th data-toggle="tooltip" data-placement="top" title="Domicilio" data-events="operateEvents" data-halign="center" data-width="25" data-align="center" data-field="Domicilio" data-sortable="true">
                                    Domicilio
                                </th>
                                <th data-toggle="tooltip" data-placement="top" title="Estatus" data-halign="center" data-width="10" data-align="center" data-field="Estatus" data-sortable="true">
                                    Estatus
                                </th>
                                <th data-toggle="tooltip" data-placement="top" title="Fecha de resultado" data-halign="center" data-width="10" data-align="center" data-field="fechaResultado" data-sortable="true">
                                    Fecha de resultado
                                </th>
                            </tr>
                        </thead>
                    </table>
                    <!-- <div v-show="cargandoCedulas" class="contenedor-cargando" style="height: 300px ;">
                        <div class="text-center">
                            <i class="fas fa-spinner fa-spin fa-5x"></i>
                            <h4 class="mt-4">Cargando Cédulas</h4>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import enumeraciones from '@/../static/js/enumeraciones'
import comun from "@/../static/js/comun"
import api from '@/../static/js/api'
import axios from 'axios'
import catalogos from '@/../static/js/catalogos'
import VueMask from 'v-mask'

Vue.use(VueMask);
export default {
    props: {
        seccionDeLaPaginaWeb: Object
    },
    components: {
        C001Area: catalogos.PJ.C001Area,
        C004TiposDocumento: catalogos.PJ.C004TipoDocumento
    },
    data() {
        return {
            enumeraciones,
            tablaCedulas: {
                ID: 'Tabla-bitacora-cedula',
                filtros: {
                    filtroAreaInformativo: false,
                    juzgadoId: -1,
                    numeroExpediente: null,
                    fechaInicial: /* moment().subtract(5, 'days').format('YYYY-MM-DD') */ null,
                    fechaFinal:  /* moment().format('YYYY-MM-DD') */ null,
                    contFJuzgado: 1,
                    tipoDeDocumento: {
                        parametros: { soloDocumentosPrincipales: true },
                        tipoDeDocumentoId: -1,
                        lista: [],
                        contadorRender: 1
                    },
                    grupos: { 
                        rangoDeFechas: { activo: true } 
                    }
                },
                cedulas: []
            },
            visor: {
                cedulaSeleccionada: null,
                HEIGHT: '600px',
                contRender: 1
            },
            cargoAreaDeUsuario: false,
            cargandoCedulas: false
        }
    },
    methods: {
        limpiarFiltros: function() {
            this.tablaCedulas.filtros.numeroExpediente = null;
            this.tablaCedulas.filtros.fechaInicial = moment().subtract(5, 'days').format('YYYY-MM-DD');
            this.tablaCedulas.filtros.fechaFinal =  moment().format('YYYY-MM-DD');
            this.tablaCedulas.filtros.grupos.rangoDeFechas.activo = true;
            this.tablaCedulas.filtros.tipoDeDocumento.tipoDeDocumentoId = -1;
            this.tablaCedulas.filtros.tipoDeDocumento.contadorRender ++;
        },
        /**
         * Metodo encargado de iniciar el proceso de busqueda y inicializacion de la tabla con el contenido
         * @see {@link construirPeticionBusquedaDeCedulas}
         * @see {@link obtenerCedulasBD}
         * @see {@link inicializarTabla}
         */
        iniciarProcesoBusquedaDeCedulas: async function() {
            const { sePuedeContinuar, mensaje } = this.validarFiltrosDeBusqueda();
            if(sePuedeContinuar) {
                this.cargandoCedulas = true;
                const PETICION_API = await Promise.resolve(this.construirPeticionBusquedaDeCedulas());
                const SE_OBTUVIERON_CEDULAS = await Promise.resolve(this.obtenerCedulasBD({ peticion: PETICION_API }));
                if(SE_OBTUVIERON_CEDULAS)
                    await Promise.resolve(this.inicializarTabla({ elementos: this.tablaCedulas.cedulas }));
                this.cargandoCedulas = false;
            }
            else {
                comun.mensajeDeAlerta(mensaje);
            }
        },
        validarFiltrosDeBusqueda: function() {
            const { juzgadoId, numeroExpediente, fechaInicial, fechaFinal, grupos, tipoDeDocumento } = this.tablaCedulas.filtros;
            let estadoDeValidacion = { sePuedeContinuar: true, mensaje: null };
            if(!this.campoRequeridoEsValido(juzgadoId)) {
                estadoDeValidacion = { sePuedeContinuar: false, mensaje: 'Debes seleccionar un juzgado valido' }
            }
            else if(!this.campoRequeridoEsValido(numeroExpediente)) {
                estadoDeValidacion = { sePuedeContinuar: false, mensaje: 'Debes seleccionar un número de expediente valido' }
            }
            else if(!this.campoRequeridoEsValido(tipoDeDocumento.tipoDeDocumentoId)) {
                estadoDeValidacion = { sePuedeContinuar: false, mensaje: 'Debes seleccionar un tipo de documento valido' }
            }
            /* else if(this.tablaCedulas.filtros.grupos.rangoDeFechas.activo) {
                if(!this.campoRequeridoEsValido(fechaInicial)) {
                    estadoDeValidacion = { sePuedeContinuar: false, mensaje: 'Debes seleccionar un fecha inicial valida' }
                }
                if(!this.campoRequeridoEsValido(fechaFinal)) {
                    estadoDeValidacion = { sePuedeContinuar: false, mensaje: 'Debes seleccionar un fecha final valida' }
                }
            } */
            return estadoDeValidacion;
        },
        /**
         * Funcion encargada de construr la peticion para el servicio REST para la consulta de cedulas
         * formato = [JuzgadoId, Consecutivo, TipoDeCedulaId, TipoDeEstatusId, TipoDeEstatusId, FechaInicial, FechaFinal, EsPrueba]
         */
        construirPeticionBusquedaDeCedulas: async function() {
            const { juzgadoId, numeroExpediente, fechaInicial, fechaFinal, grupos, tipoDeDocumento } = this.tablaCedulas.filtros;
            let peticion = {};
            peticion.JuzgadoId = (this.campoRequeridoEsValido(juzgadoId)) ? juzgadoId : null;
            peticion.Consecutivo = (this.campoRequeridoEsValido(numeroExpediente)) ? numeroExpediente : null;
            peticion.TipoDeCedulaId =  null;
            peticion.FechaInicial = (this.campoRequeridoEsValido(fechaInicial) && grupos.rangoDeFechas.activo) ? fechaInicial : null;
            peticion.FechaFinal = (this.campoRequeridoEsValido(fechaFinal) && grupos.rangoDeFechas.activo) ? fechaFinal : null;
            peticion.TipoDocumentoId = (this.campoRequeridoEsValido(tipoDeDocumento.tipoDeDocumentoId)) ? tipoDeDocumento.tipoDeDocumentoId : null;
            peticion.EsPrueba = false;
            return peticion;
        },
        obtenerColorDeEstatus: function({ estatusSTR }) {
            const COLOR_ESTATUS_PENDIENTE = '#DC7633';
            const COLOR_ESTATUS_GENERICO = '#2E7D32'
            return {
                color: (estatusSTR == 'PENDIENTE') ? COLOR_ESTATUS_PENDIENTE : COLOR_ESTATUS_GENERICO,
                icono: (estatusSTR == 'PENDIENTE') ? 'fas fa-clock' : 'fas fa-check-circle'
            }
        },
         /**
         * Funcion encargada de llamar a servicio REST para obtener las cedulas
         * @param {Object} peticion [valor correspondiente al objeto POST del servicio REST]
         * @param {Boolean} conMensajeDeRespuesta [valor correspondiente a la validacion para mostrar mensaje en el sistema con la respuesta de la peticio del servicio REST]
         */
        obtenerCedulasBD: async function({ peticion, conMensajeDeRespuesta = true }) { 
            let procesoSinError = false;
            try {
                moment.locale('es');
                const SERVIDOR = api.conexion;
                const METODO_API_OBTENER = api.SINOJ.sistema.consultas.consultaPublica.ConsultaPublicaGeneral;
                const URL_API_SERVICIO = SERVIDOR + METODO_API_OBTENER;
                const HEADER_PARA_ENVIO_ARCHIVOS = false;
                const HEADER_PARA_ARRAY_BUFFER = false;
                const HEADER_PETICION = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, HEADER_PARA_ENVIO_ARCHIVOS,HEADER_PARA_ARRAY_BUFFER);
                comun.SeEstaCargandoInformacion(true,true);
                const RESPUESTA_SOLICITUD = await axios.post(URL_API_SERVICIO, peticion, HEADER_PETICION);
                const DATOS_RESPUESTA = await RESPUESTA_SOLICITUD.data;
                let { SiHayError, Error, Cedulas, Satisfactorio } = DATOS_RESPUESTA;
                if (SiHayError) {
                    let mensajeError = Error.Mensaje;
                    console.log(Error);
                    comun.SeEstaCargandoInformacion(false,true);
                    comun.mensajeDeAlerta(mensajeError);
                    await Promise.resolve(this.inicializarTabla({ elementos: [] }));
                } 
                else { 
                    moment.locale('es');
                    this.tablaCedulas.cedulas = (this.campoRequeridoEsValido(Cedulas)) 
                        ? Cedulas.map(cBD => {
                            let cedulaObj = { ...cBD };
                            let { color, icono } = this.obtenerColorDeEstatus({ estatusSTR: cedulaObj.Estatus });
                            cedulaObj.Estatus = `<div style="border-radius: 3px; padding-top: 0.5em; padding-bottom: 0.5em; display: flex; align-items: center; justify-content: center; border: 2px solid ${ color };">
                                                    <strong><i class="${ icono }" style="color: ${ color }"></i>&nbsp;&nbsp;${ cedulaObj.Estatus }</strong>
                                                 </div>`;
                            cedulaObj.fechaResultado = (this.campoRequeridoEsValido(cedulaObj.fechaResultado)) 
                                //? `<strong>${ cedulaObj.fechaResultado.substring(0,10) }</strong>`
                                ? `<strong>${ moment(cedulaObj.fechaResultado).format("DD MMMM YYYY") }</strong>`
                                : '';
                            cedulaObj.FechaEnvioADireccion = (this.campoRequeridoEsValido(cedulaObj.FechaEnvioADireccion)) 
                                ? `<strong>${ moment(cedulaObj.FechaEnvioADireccion).format("DD MMMM YYYY") }</strong>`
                                : ''
                            return cedulaObj;
                        })
                        : [];
                    procesoSinError = true;
                    if(conMensajeDeRespuesta && this.campoRequeridoEsValido(Satisfactorio))
                        comun.mensajeDeAlerta(Satisfactorio);
                }
                comun.SeEstaCargandoInformacion(false,true);
            }
            catch(excepcion) {
                console.log(excepcion);
                comun.SeEstaCargandoInformacion(false,true);
                comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
            }
            return procesoSinError;
        },
        manipularVisualizacionModal: function({ idModal, mostrar }) {
            const ACCION = (mostrar) ? 'show' : 'hide';
            $('#' + idModal).modal(ACCION);
        },
        evtCambioDeJuzgado: function(evento) {
            this.tablaCedulas.filtros.juzgadoId = parseInt(evento.target.value);
        },
        evtCambioTipoEstatus: function(evento) {
            this.tablaCedulas.filtros.estatus.tipoDeEstatusId = parseInt(evento.target.value);
        },
        evtCambioTipoNotificacion: function(evento) {
            this.tablaCedulas.filtros.tipoNotificacion.tipoNotificacionId = parseInt(evento.target.value);
        },
        evtCambioTipoDeDocumento: function(evento) {
            this.tablaCedulas.filtros.tipoDeDocumento.tipoDeDocumentoId = parseInt(evento.target.value);
        },
         /**
         * Funcion encargada de inicializar los contenidos de la cedulas
         * @param {Array} elementos [lista de cedulas a mostrar]
         */
        inicializarTabla: async function({ elementos }) { 
            this.$nextTick(() => {
                $("#" + this.tablaCedulas.ID).bootstrapTable({  data: elementos });      
                $("#" + this.tablaCedulas.ID).bootstrapTable('load', elementos ); 
            });
        },
        campoRequeridoEsValido: function(campo) { 
          let esValido = false
          if(typeof campo === 'string' || campo instanceof String) {
              // valida que filtro tipo cadena no sea nula, indefinida y compuestas solo de espacios en blanco o saltos de linea
              if (campo != null && campo != undefined && campo != '' && campo.replace(/\s/g, '').length) {
                  esValido = true;
              }
          }
          else if (typeof campo === 'number' || campo instanceof Number) {
              // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
              if (campo != null && campo != undefined && campo > 0) {
                  esValido = true;
              }
          }
          else if (typeof campo === 'array' || campo instanceof Array) {
              // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
              if (campo != null && campo != undefined && campo.length > 0) {
                  esValido = true;
              }
          }
          else {
              if (campo != null && campo != undefined) {
                  esValido = true;
              }
          }
          return esValido;
      },
    },
    async mounted() {
        window.operateEvents = {
            
        };
        await Promise.resolve(this.inicializarTabla({ elementos: this.tablaCedulas.cedulas }));
    } 
}
</script>
<style scoped>
.contenedor-cargando {
    background-color: rgb(36, 34, 34);
    height: 40px;
    height: 21rem;
    display: flex;
    align-items: center;
    justify-content: center;
}

#contenedor-principal-consulta-publica-notificaciones {
    padding-top: 5em;
    padding-bottom: 5em;
}

#seccion-consulta h6 {
    color: black;
    font-weight: bold;
}

#visor-documentos .modal-lg {
    max-width: 70% !important;
}

#visor-documentos .modal-header {
    background-color: rgb(36, 34, 34);;
    border: none;
}

.catalogoInformativo {
    pointer-events:none;
    cursor: not-allowed;
    opacity: 0.5;
}

.texto-filtros {
    font-size: 1.1em;
}

.acciones {
    border-top: 1px solid rgb(27, 27, 27);
    background-color: #444444;
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 4px;
}

#seccion-acciones .btn {
    padding: 0.3em 0.8em 0.3em 0.8em;
    font-size: 1.5vmin;
    background-color: black;
}

.titulo-contenedores-seccion h5 {
    font-size: 2.7vmin;
}

.titulo-contenedores-seccion {
    background-color: rgb(71, 71, 71);
    padding: 1.3em 2em 0.5em 2em;
    color: white;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
}

.contenedor-color-negro {
    background-color: #dbdbdb;
    padding: 25px;
    border: 1px solid rgb(27, 27, 27);
}

#encabezados {
    margin-bottom: 1em;
}

#encabezados h1 {
    margin-bottom: 0;
    font-weight: bold;
}

#encabezados h4 {
    font-size: 1.5em;
    color: rgb(129, 126, 126);
}

.hr-titulo {
    height:0.5em;
    width: 6em;
    border:none;
    background-color:#ffffff;
}
</style>
<style>
#contenedor-principal-consulta-publica-notificaciones .form-control {
    background-color: white;
    color: rgb(63, 62, 62) !important;
    border: 1px solid #656161 !important;
}

#Tabla-bitacora-cedula {
    margin-top: -3em;
}
.fixed-table-toolbar {
    z-index: unset !important; 
}

#filtros .input-group-text {
    border-top-left-radius: 0.6vmin;
    border-bottom-left-radius: 0.6vmin;
    border: none;
}

#filtros .form-control {
    border: none !important;
}

.contenedor-tabla-historico-CEDULAS-SINOJ .btn-secondary {
    width: 2.5rem;
    background-color: #1f1f21;
    color: white;
    padding: 0.3em 0.3em 0.3em 0.3em;
    box-shadow: none;
}

.contenedor-tabla-historico-CEDULAS-SINOJ .form-control {
    background-color: white;
    color: rgb(63, 62, 62);
    border: 1px solid #656161 !important;
    height: 2.5em;
    width: 40vmin;
}

.contenedor-tabla-historico-CEDULAS-SINOJ td {
    background-color: rgb(238, 238, 238);
    vertical-align: middle;
}

.borderless td, .borderless th {
    border: none;
    border-bottom: 1px solid #d8d7d7 !important;
}

.contenedor-tabla-historico-CEDULAS-SINOJ .btn-light {
    background-color: white;
    border: 1px solid #4F4949;
    color: #AF9C9C;
    font-size: 1em;
}

.contenedor-tabla-historico-CEDULAS-SINOJ .btn-ver-documento-SINOJ:hover, .contenedor-tabla-historico-CEDULAS-SINOJ .btn-ver-documento-SINOJ:focus {
    background-color: #1c1d1d;
    border: 1px solid #e1e2e2;
    color: white;
}

.contenedor-tabla-historico-CEDULAS-SINOJ .fixed-table-container {
    margin-top: -5em !important;
    margin-bottom: -4.5em !important;
}

.contenedor-tabla-historico-CEDULAS-SINOJ table {
    table-layout: fixed;
    width: 100%;
    word-wrap:break-word;
}

.contenedor-tabla-historico-CEDULAS-SINOJ .dropdown-toggle {
    width: 3.3rem;
    background-color: #1f1f21;
    color: white;
}

.contenedor-tabla-historico-CEDULAS-SINOJ .pagination > li > a {
    background-color: white;
    color: #121213;
}

.contenedor-tabla-historico-CEDULAS-SINOJ .pagination > .active > a {
    color: white;
    background-color:  #1f1f21;
    border: solid 1px #676666;
}

.contenedor-tabla-historico-CEDULAS-SINOJ > .active > a:hover {
    background-color:  #21211f;
    border: solid 1px #676666;
}
.contenedor-descripcion {
    background: white;
    border-radius:2px;
    padding: 10px;
    border:1px solid rgba(22, 22, 22, 0.767);
    margin-bottom: 1.5em;
  }
</style>


// WEBPACK FOOTER //
// src/components/PaginaOficial/PaginaInformativa/Notificaciones/Civiles/ConsultaDeCedulas.vue